import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetDripSequenceEditionStubs as GetDripSequenceEditionStubsQuery,
    GetDripSequenceEditionStubsVariables as GetDripSequenceEditionStubsQueryVariables,
    EditionStubFragment as EditionStub,
} from 'nutshell-graphql-types';

import {getDripSequenceEditionStubsQueryVariables} from '../helpers';

import GET_EDITIONS from './graphql/queries/get-drip-sequence-edition-stubs.graphql';

type Props = {
    dripSequenceId: string;
    skip?: boolean;
    isArchived?: boolean;
    children: (arg1: {
        editions: EditionStub[];
        error: string | null | undefined;
        isLoading: boolean;
        refetch: () => Promise<any>;
    }) => React.ReactElement;
};

export function DripSequenceEditionStubsQuery(props: Props) {
    const variables = getDripSequenceEditionStubsQueryVariables(
        props.dripSequenceId,
        props.isArchived
    );

    const {
        data,
        loading: isLoading,
        error,
        refetch,
    } = useQuery<GetDripSequenceEditionStubsQuery, GetDripSequenceEditionStubsQueryVariables>(
        GET_EDITIONS,
        {
            skip: props.skip,
            variables: variables,
            fetchPolicy: 'cache-and-network',
            notifyOnNetworkStatusChange: true,
        }
    );

    const editionsData = data && data.dripSequence ? data.dripSequence.editions : null;

    const editions = editionsData
        ? editionsData.edges.map((edition) => {
              return edition.node;
          })
        : [];

    return props.children({
        editions,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        refetch,
    });
}
